export default function IncompleteModal({
    setShowIncompleteModal,
    unansweredQuestions
}) {
    return (
        <div
            className="position-fixed top-0 start-0 bottom-0 end-0 d-flex align-items-center justify-content-center"
            style={{
                zIndex: 9999,
                backdropFilter: 'blur(4px)'
            }}
            onClick={() => setShowIncompleteModal(false)}
        >
            <div
                className="bg-white rounded-4 shadow-lg"
                style={{
                    maxWidth: '650px',
                    width: '90%',
                    maxHeight: '90vh',
                    overflow: 'hidden',
                    display: 'flex',
                    flexDirection: 'column',
                    animation: 'modalSlideIn 0.3s ease-out'
                }}
                onClick={(e) => e.stopPropagation()}
            >
                {/* Header */}
                <div
                    className="text-center position-relative"
                    style={{
                        background: 'var(--ink)',
                        padding: '2.5rem 2rem 2rem',
                        borderBottom: '3px solid var(--accent)'
                    }}
                >
                    <div
                        className="position-absolute top-0 end-0 m-3"
                        style={{ cursor: 'pointer', opacity: 0.8 }}
                        onClick={() => setShowIncompleteModal(false)}
                    >
                        <i className="fas fa-times text-white" style={{ fontSize: '1.25rem' }}></i>
                    </div>

                    <div
                        className="d-inline-flex align-items-center justify-content-center mb-3"
                        style={{
                            width: '80px',
                            height: '80px',
                            borderRadius: '50%',
                            backgroundColor: 'rgba(199, 29, 150, 0.15)',
                            border: '3px solid var(--accent)'
                        }}
                    >
                        <i className="fas fa-exclamation-triangle" style={{ fontSize: '2.5rem', color: 'var(--accent)' }}></i>
                    </div>

                    <h3 className="text-white mb-2" style={{ fontWeight: '700', letterSpacing: '-0.5px' }}>
                        Incomplete Submission
                    </h3>
                    <p className="text-white mb-0" style={{ opacity: 0.9, fontSize: '0.95rem' }}>
                        {unansweredQuestions.length} question{unansweredQuestions.length > 1 ? 's require' : ' requires'} your attention
                    </p>
                </div>

                {/* Body */}
                <div
                    className="p-4"
                    style={{
                        overflowY: 'auto',
                        flex: 1
                    }}
                >
                    <div
                        className="alert mb-4"
                        style={{
                            backgroundColor: 'var(--accent-soft)',
                            border: '1px solid var(--hairline)',
                            borderLeft: '4px solid var(--accent)',
                            borderRadius: '8px'
                        }}
                    >
                        <div className="d-flex align-items-start">
                            <i className="fas fa-info-circle me-3 mt-1" style={{ color: 'var(--accent)', fontSize: '1.1rem' }}></i>
                            <small className="text-dark" style={{ lineHeight: '1.6' }}>
                                Please complete all required questions before submitting. Unanswered questions are highlighted below.
                            </small>
                        </div>
                    </div>

                    <div className="mb-3">
                        <h6 className="text-uppercase fw-bold mb-3" style={{ color: 'var(--ink)', fontSize: '0.75rem', letterSpacing: '1.5px' }}>
                            Missing Responses ({unansweredQuestions.length})
                        </h6>

                        <div className="d-flex flex-column gap-3">
                            {unansweredQuestions.map((q, index) => {
                                const templateName = q.pirm_addon__Question__r?.pirm_addon__Template__r?.Name || "General Section";

                                return (
                                    <div
                                        key={q.Id}
                                        className="border rounded-3 overflow-hidden transition-all"
                                        style={{
                                            borderColor: 'var(--hairline)',
                                            transition: 'all 0.2s ease',
                                            cursor: 'pointer'
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.borderColor = 'var(--accent)';
                                            e.currentTarget.style.boxShadow = '0 4px 12px rgba(199, 29, 150, 0.15)';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.borderColor = 'var(--hairline)';
                                            e.currentTarget.style.boxShadow = 'none';
                                        }}
                                    >
                                        <div className="d-flex align-items-start p-3 bg-white">
                                            <div
                                                className="d-flex align-items-center justify-content-center me-3 flex-shrink-0"
                                                style={{
                                                    width: '36px',
                                                    height: '36px',
                                                    borderRadius: '8px',
                                                    backgroundColor: 'var(--accent)',
                                                    color: 'white',
                                                    fontWeight: '700',
                                                    fontSize: '0.9rem'
                                                }}
                                            >
                                                {q.pirm_addon__Question_Order__c}
                                            </div>

                                            <div style={{ flex: 1 }}>
                                                <div
                                                    className="d-flex align-items-center mb-2"
                                                    style={{ gap: '8px' }}
                                                >
                                                    <span
                                                        className="badge text-uppercase"
                                                        style={{
                                                            backgroundColor: 'rgba(36, 4, 59, 0.1)',
                                                            color: 'var(--ink)',
                                                            fontSize: '0.65rem',
                                                            fontWeight: '600',
                                                            letterSpacing: '0.5px',
                                                            padding: '4px 10px',
                                                            borderRadius: '4px'
                                                        }}
                                                    >
                                                        <i className="fas fa-folder-open me-1" style={{ fontSize: '0.6rem' }}></i>
                                                        {templateName}
                                                    </span>
                                                </div>

                                                <div
                                                    className="fw-medium"
                                                    style={{
                                                        color: 'var(--ink)',
                                                        fontSize: '0.95rem',
                                                        lineHeight: '1.6'
                                                    }}
                                                >
                                                    {q.pirm_addon__Question_Text_Rich__c?.replace(/<[^>]*>?/gm, '') || q.pirm_addon__Question_Text__c}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>

                {/* Footer */}
                <div
                    className="p-4 border-top text-center"
                    style={{
                        borderColor: 'var(--hairline)',
                        backgroundColor: 'var(--surface-sunken)'
                    }}
                >
                    <div className="d-flex justify-content-center">
                        <button
                            className="btn px-5 py-2 fw-semibold shadow-sm"
                            style={{
                                borderRadius: '8px',
                                backgroundColor: 'var(--accent)',
                                color: 'white',
                                border: 'none',
                                transition: 'all 0.2s ease'
                            }}
                            onClick={() => setShowIncompleteModal(false)}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor = 'var(--accent-strong)';
                                e.currentTarget.style.transform = 'translateY(-1px)';
                                e.currentTarget.style.boxShadow = '0 6px 20px rgba(199, 29, 150, 0.3)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor = 'var(--accent)';
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.1)';
                            }}
                        >
                            <i className="fas fa-edit me-2"></i>
                            Complete Questions
                        </button>
                    </div>

                    <small className="d-block mt-3 text-muted" style={{ fontSize: '0.8rem' }}>
                        Questions will pulse with a red border until answered
                    </small>
                </div>
            </div>

            <style dangerouslySetInnerHTML={{
                __html: `
            @keyframes modalSlideIn {
                from {
                    opacity: 0;
                    transform: translateY(-20px);
                }
                to {
                    opacity: 1;
                    transform: translateY(0);
                }
            }
        `}} />
        </div>
    )
}
